<template>
  <base-section id="content">
    <v-container>
      <v-row>
        <p class="c3">
          <span class="c0"
            >Sunburnt, cheery, and devil-may-care; the head pastor of WGC Missions Inc.
            had fancied himself a qualified aviator, even to the end. Gnashing and
            wailing all the way down, the single-engine carrying Anna from Jakarta to
            Papua New Guinea fell into the sea a little before noon. She clung to a rosy
            plastic suitcase throughout the day and into the night, losing sight of the
            other bits of wreckage, speck after speck. Losing sight of all but water.
            Remnants drifted, or she drifted, until Anna was utterly separate; the
            solitary form in the broad, heaving, smoke-colored ocean.</span
          >
        </p>
        <p class="c3">
          <span class="c5"
            >&ldquo;Jesus,&rdquo; she whispered without sound into the night. Her vision
            darkened and flashed white in turns. &ldquo;Oh, my Jesus. Send someone to
            find me.&rdquo; But he didn&rsquo;t. He just </span
          ><span class="c4">left</span><span class="c0">&nbsp;her there.</span>
        </p>
        <p class="c3">
          <span class="c5"
            >She&rsquo;d given up everything, all possessions and desires, for the Lord.
            His purpose was her purpose; and he was going to kill her off before she
            even arrived? That was&hellip;</span
          ><span class="c4">unexpected</span
          ><span class="c0"
            >. Anna laid her head down on the case and closed her eyes, remembering the
            words, &ldquo;Whatever his soul desires, that he does.&rdquo; The waves
            heaved and moonlight shifted across her eyelids. &ldquo;Therefore, I am
            terrified at his presence.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >A wave caught Anna&rsquo;s suitcase, sucking her under, choking and then
            releasing her. Anna pressed her face against the hard plastic. &ldquo;The
            terrors of God are arrayed against me. But why Lord,&rdquo; she added to the
            text, &ldquo;why have you left me here to die?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >The sea suddenly quieted, darkness covering the face of the waves. Anna
            lifted her head, clinging tightly to the edges of her case, more terrified
            now than when the plane had crashed. It was as if her eyes had been dialed
            off. Perhaps, she swallowed, perhaps it had been foolish to question one who
            had the power to make things even worse. Had he struck her blind? There was
            nothing to see. Nothing but darkness.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Gradually, the darkness seemed to draw back. Became less.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Moonlight began to soak through the clouds, a greenish glow separating the
            sky from the sea. Sound returned. A gentle hiss, like the breath of a
            sleeping man. The sea breathed in. The sea breathed out. The sea breathed
            in. Anna felt a touch on her back and screamed.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Hands reached under her arms and heaved her up out of the water. Her legs
            scraped across the rough edge of the boat and she landed face down on the
            grayish, splintering planks. She gasped heavily, face on the floor; the
            chalky, sour scent of the rotting wood filling her mouth.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;Can you move?&rdquo; The voice was gravelly, gray and indistinct as
            the boat. &ldquo;Are you injured?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna lifted her head a few inches, her wet, tangled hair clinging to her
            face. She turned slowly toward the bow. She saw the empty boat, and she saw
            the man at the same time. He wasn&rsquo;t there, but she could see him with
            her mind. Like imagining something while her eyes were still open, except
            that there was no concentration required. She didn&rsquo;t have to think
            about his boots, and yet they were there, pressed flat against the deck. He
            sat, staring down at her, elbows on his knees, breathing heavily from
            exertion. She knew he did this, while at the same time, she was alone.
            &ldquo;Speak, please,&rdquo; he said. She heard it, but not with her ears;
            it was like a voice from a memory she didn&rsquo;t have.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna pushed herself to her knees, her white sundress plastered to her
            thighs. She brushed another clump of hair away from her eyes and stared into
            his face, a faint light glowing from it. He was colorless, but handsome. His
            white shirt was disheveled and not blowing in correct time with the wind
            that moved past him; strands of wavy hair escaping the tie at his neck. He
            looked concerned. Anna lifted her hand and moved it slowly toward him, palm
            up. He reached forward in the same way and pressed his hand against hers.
            There was pressure, tangible physical pressure, and yet she felt it
            intermittently. Like the buzz of a touch on a numbed scar. Anna took a deep
            breath, &ldquo;Are you Jesus?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >He pulled his hand away abruptly. &ldquo;I certainly hope not.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna sat back on her heels. Not Jesus. There was nothing for it; she
            started to cry.</span
          >
        </p>
        <p class="c3"><span class="c0">***</span></p>
        <p class="c3">
          <span class="c0"
            >Anna had just worked herself into a new bout of hysterics when Daniel
            dropped the oars. &ldquo;Woman, please!&rdquo; He leaned toward her, looking
            extremely annoyed. &ldquo;Compose yourself.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c5"
            >She choked on her latest rant about the appalling lack of psychiatrists and
            CT scanning equipment in the seas of Indonesia. &ldquo;How do you </span
          ><span class="c4">know</span
          ><span class="c0">&nbsp;I&rsquo;m not dead?&rdquo;</span>
        </p>
        <p class="c3">
          <span class="c0"
            >He stood and extended his hand toward her. &ldquo;If you are dead, then why
            did you bother bringing me up to save you?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c5"
            >Anna leaned back and pulled her dress down over her knees. &ldquo;I did </span
          ><span class="c4">not</span><span class="c0">.&rdquo;</span>
        </p>
        <p class="c3">
          <span class="c0">He stared back at her, eyebrows raised.</span>
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;You think I summoned you? Like&hellip; like a witch, or
            something?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Daniel shrugged, and then reached for her hand again. &ldquo;Come;
            we&rsquo;ve reached the island.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;No way.&rdquo; Anna clasped her hands behind her back. &ldquo;What
            are you going to do with me?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Daniel didn&rsquo;t answer, but leaned forward suddenly and picked her up
            by the waist.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;No, stop!&rdquo; Anna squirmed, but he simply threw her over his
            shoulder and began to climb out of the boat. It was awful. Nothing beneath
            her except either an annoyed, incandescent ghost, or empty air and black
            surf. &ldquo;Please!&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >He ignored her completely. She breathed as best she could, watching the
            water churn mysteriously as he sloshed through it, watching the patches of
            sand light up and depress with his footsteps. He stopped after few dozen
            yards and set her down facing him. His shoulders sagged and he blew out a
            breath. &ldquo;Anna, I have no idea why we&rsquo;ve been thrown together
            like this. But I have just plucked you from certain death in the middle of
            the ocean, and I would appreciate it very much if you would calm
            down.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna closed her mouth and plucked at her still-sopping dress.
            &ldquo;I&rsquo;m calm.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0">&ldquo;You are screaming like a banshee.&rdquo;</span>
        </p>
        <p class="c3"><span class="c0">&ldquo;Oh.&rdquo;</span></p>
        <p class="c3">
          <span class="c0"
            >He nodded behind her. &ldquo;This house looks empty. Would you like to go
            in?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna turned around and saw the door of a large stone and teak building. She
            went inside after Daniel and followed him through the house until he found a
            room for her to sleep in.</span
          >
        </p>
        <p class="c3">
          <span class="c5"
            >She lay awake for some time, listening to Daniel&rsquo;s footsteps as he
            explored the house, opening cabinets, removing the white sheets that covered
            all the furniture. She curled herself into a ball, willing him back to the
            netherworld, willing herself back to sanity. &ldquo;Please. Please
            God.&rdquo; There was a dull thud and then sharp </span
          ><span class="c4">plink</span
          ><span class="c0"
            >&nbsp;of a piano key. Anna rolled over, covered her face with the thin
            white blanket, and fell asleep to Haydn.</span
          >
        </p>
        <p class="c3"><span class="c0">***</span></p>
        <p class="c3">
          <span class="c0"
            >Anna woke to the late afternoon sun in her eyes and a mosquito on her
            wrist. She sat up, about to start screaming again, but paused when saw the
            note near her pillow.</span
          >
        </p>
        <p class="c3">
          <span class="c4 c9"
            >Remember, you are not dead. There is food on the table. Please change your
            gown; I can see right through it. - Daniel</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;Cute.&rdquo; Anna crushed the paper in her fist.
            &ldquo;Cute.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >She searched the entire house, but Daniel was gone. The place appeared to
            be the vacation cottage of people who could afford their own island, built
            on sand because they could. Wine glasses enough to serve two dozen guests,
            the majority still bearing their stickers; each book she opened cracked its
            spine for the first time. No telephone service or spare clothing; only the
            necessities for those who would arrive by yacht. There was a guestbook of
            sorts, though, commemorating each visit. Eight months until Massimo and
            Bianca&rsquo;s anniversary, the only time of year they could reliably be
            expected.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna closed the book and stared toward the bowl of starfruit that had been
            laid out for her, then went out to the beach to look for signs of life.
            There were none, of course; and no boat, either. With all her shrieking,
            he&rsquo;d probably forgotten to tie it up. Anna exhaled, watching the sun
            plunge slowly into the ocean. &ldquo;Eight months.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Why had God done this thing? She wasn&rsquo;t dead, and she wasn&rsquo;t
            crazy. She hadn&rsquo;t lifted herself out of the water, and she certainly
            hadn&rsquo;t written herself any witty notes. And Daniel? Nowhere in her
            scanty theological education had she heard of any spirit like him. A demon,
            then? A handsome, sarcastic, piano playing demon that rescued girls from
            plane wrecks while donning nineteenth-century fashions. Mm-hmm. That was
            it.</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Daniel spoke from beside her, and Anna peed her pants. Since she
            wasn&rsquo;t wearing pants, it ran straight down her legs onto the sand.
            Daniel looked up from her wet feet to her face. &ldquo;Lovely.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >Anna squared her shoulders and walked toward the water to rinse her legs.
            &ldquo;I refuse to feel embarrassed in front of a dead person.&rdquo; She
            dipped herself all the way to the neck to make her dress see-through again,
            just to further prove the point. &ldquo;Where were you, anyway?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;I took the boat out last night to find help, caught sight of the
            rising sun, and woke up standing here.&rdquo; He glanced around. &ldquo;It
            hasn&rsquo;t returned on its own, by any chance?&rdquo;</span
          >
        </p>
        <p class="c3"><span class="c0">Anna shook her head and stood up.</span></p>
        <p class="c3">
          <span class="c0"
            >Daniel rolled his eyes as she walked toward him in her transparent dress.
            &ldquo;Is this your usual method of frightening off male
            spirits?&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;I did not conjure you.&rdquo; Anna went to stand beside him and look
            out over the darkening surf, crossing her arms over her chest.
            &ldquo;I&rsquo;m a missionary, in fact. Or, I&rsquo;m going to
            be.&rdquo;</span
          >
        </p>
        <p class="c3">
          <span class="c0"
            >&ldquo;Ah, yes?&rdquo; Daniel rocked on his heels, smiling toward the
            water.</span
          >
        </p>
        <p class="c3">
          <span class="c5">&ldquo;My plane&mdash;&rdquo; Wait. That&rsquo;s it! </span
          ><span class="c4">Whatever his soul desires, that he does.</span
          ><span class="c0"
            >&nbsp;Even causing donkeys to speak or bringing up the dead. Perhaps this
            wasn&rsquo;t a demonic accident after all, but a miracle. She spun to face
            Daniel. &ldquo;Are you saved?&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">He looked startled.</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Have you heard the gospel?&rdquo; She grabbed his arm with both
            hands. &ldquo;I can tell you all about Jesus Christ. That&rsquo;s why
            we&rsquo;re&mdash;&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;What do you take me for, woman? Some ignorant island savage?&rdquo;
            Daniel pulled his arm out of her grasp. &ldquo;And I believe I know a bit
            more about the afterlife than you.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Oh.&rdquo; Anna dropped her hands. &ldquo;Well, then.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Besides, it just so happens that was how I came to be near this
            place, myself. I journeyed with a group of priests through Java, and we were
            set upon by one of the, uh...&rdquo; Daniel made a face and scratched behind
            his ear, &ldquo;cannibalistic tribes.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;I&rsquo;m sorry. That&rsquo;s&mdash;&rdquo; she paused suddenly.
            &ldquo;Oh.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Yes, well.&rdquo; Daniel cleared his throat. &ldquo;I was habitually
            reckless and others paid dearly for my failure on that occasion. Perhaps
            saving you is a chance to purge my vices.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c5"
            >Anna creased her forehead. &ldquo;As in&hellip; you mean you&rsquo;re in </span
          ><span class="c4">purgatory</span
          ><span class="c0">?&rdquo; She glanced back at the island, skeptical.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel looked around as well. &ldquo;Yes, it does seem a bit temperate,
            does it not?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Island paradise, no fire to be seen&hellip;&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Although,&rdquo; said Daniel. &ldquo;There has been screaming
            aplenty.&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">Anna scowled.</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;A nighttime existence,&rdquo; he continued. &ldquo;No proper body...
            Still, it is not what I expected.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;I don&rsquo;t know,&rdquo; said Anna. &ldquo;A little heaven, a
            little hell. Sounds about right.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel looked aghast. &ldquo;Who taught you your catechism? A little hell,
            indeed.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;No need to be rude,&rdquo; she snapped. &ldquo;And no one taught me
            the catechism. I&rsquo;m not even Catholic.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel looked at her suspiciously and took a small step to the side, away
            from her.</span
          >
        </p>
        <p class="c1">
          <span class="c5">Anna gave him a dirty look. </span
          ><span class="c4">&ldquo;Anyway</span
          ><span class="c0">. You thought this whole thing was fishy, too.&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;I did,&rdquo; he said. &ldquo;Yet I still managed to refrain from
            spouting heresy.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">&ldquo;Enlighten me, Mr. Catechism.&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Purgatory is a mystery, everyone knows this.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">She laughed out loud. &ldquo;Nice try.&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel rolled his eyes. &ldquo;There is pain, but it is a blessed pain. And
            it is not akin to hellfire.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">Sure. Anna looked away and tried not to laugh.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >After a moment, it occurred to her that she ought to be more grateful to
            this ghost for rescuing her. &ldquo;Um&hellip; I&rsquo;m glad you were
            there, Daniel,&rdquo; she said, smiling a little. &ldquo;I may not have
            shown it, but&mdash;&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;No, you did not,&rdquo; said Daniel, shaking his head.</span
          >
        </p>
        <p class="c1">
          <span class="c5">Anna cleared her throat. &ldquo;I </span
          ><span class="c4">know</span
          ><span class="c0"
            >&nbsp;that. I&rsquo;m simply saying that just because it didn&rsquo;t look
            like&mdash;&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c5">&ldquo;You </span><span class="c4">looked</span
          ><span class="c0"
            >&nbsp;like a very sad, wet monkey,&rdquo; said Daniel, rocking back on his
            heels again and nodding. &ldquo;A skinny, rabid, half-drowned
            monkey.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">Anna turned and began to walk down the beach.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel was still laughing. &ldquo;A sad monkey,&rdquo; he repeated,
            following her.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Har-Har. Yes, you&rsquo;re very funny.&rdquo; Anna stopped and
            turned back to face him. &ldquo;Wait, if there&rsquo;s a yacht coming to the
            island eventually, why are you still here? I&rsquo;m safe now.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;To learn vigilance, perhaps.&rdquo; Daniel looked down at her.
            &ldquo;And to entertain you. Obviously.&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">Anna smiled.</span></p>
        <p class="c1"><span class="c0">***</span></p>
        <p class="c1">
          <span class="c0"
            >Daniel was an unfeeling, inhuman beast, and Anna told him so.</span
          >
        </p>
        <p class="c1">
          <span class="c5"
            >&ldquo;Unfeeling?&rdquo; Daniel shouted back as he stalked after her into
            the house. &ldquo;I was dredged up from the pit to </span
          ><span class="c4">save</span
          ><span class="c0"
            >&nbsp;you! Perhaps you could try to respect that.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Anna turned away from him. &ldquo;I&rsquo;m sorry I inconvenienced
            you.&rdquo; She&rsquo;d thought he&rsquo;d be pleased with the plant
            she&rsquo;d brought, not freak out about where she&rsquo;d gotten it. He was
            always fascinated by the stupid flowers and such they came across during
            their moonlit walks. Was it her fault it grew on a cliff face? It&rsquo;s
            not as if she&rsquo;d fallen off.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Damn it all,&rdquo; mumbled Daniel. &ldquo;I knew my time here would
            be severe, but you, woman, are beyond anything.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c5"
            >Anna whirled around. &ldquo;What happened to me being your chance at
            redemption? I&rsquo;m your </span
          ><span class="c4">punishment</span><span class="c0">, now?&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0">Daniel smiled. &ldquo;Is there a difference?&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >She threw the thorny flower straight at his smug face. &ldquo;You know,
            I&rsquo;ll bet those head-shrinkers took one bite, and then spit you right
            out.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">&ldquo;No need to be cruel&hellip;&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0">&ldquo;Then don&rsquo;t call me a penance!&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel closed his eyes and put a fist to his forehead. &ldquo;I don&rsquo;t
            wonder that God tried to drown you. Your natives should be singing praises
            that you never arrived to torment them, too.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Anna marched to her bedroom and slammed the door. She threw herself across
            the bed and sobbed loudly. Perhaps it was petty, but he deserved to hear
            what he&rsquo;d done. Concern for her safety was one thing, but he&rsquo;d
            completely ignored her gift and the affection behind it. He didn&rsquo;t
            have to like it, but he could at least pretend. &ldquo;Jerk,&rdquo; she
            shouted through the door.</span
          >
        </p>
        <p class="c1">
          <span class="c0">&ldquo;Ingrate,&rdquo; he shouted back.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Singing natives, indeed. Okay, maybe she&rsquo;d been a few friends short
            of a party back home, but that didn&rsquo;t mean she wouldn&rsquo;t make a
            good missionary. They were mountain people, for crying out loud. She had to
            be better than nothing. And what did he know about it, anyway?
            &ldquo;Disembodied know-it-all!&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;Witch of Endor!&rdquo;</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Arrgh!&rdquo; Anna threw a book at the door. She hated when he
            called her that. &ldquo;I&rsquo;m not even talking to you, so go
            away.&rdquo; Not her best line, but at least he shut up. Anna covered her
            head with a pillow and continued on crying, but with less enthusiasm this
            time.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel knocked at the door an hour later. &ldquo;Anna?&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;Yes?&rdquo;</span></p>
        <p class="c1">
          <span class="c5">&ldquo;I </span><span class="c4">may</span
          ><span class="c0"
            >&nbsp;have forgotten to thank you for the flowers.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >She laughed once and dried her face. &ldquo;Come in, then.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel sat down beside to her on the bed. She hadn&rsquo;t lit the lamp,
            and the only light in the room came from his body. &ldquo;I know you were
            careful on the cliff,&rdquo; he said. &ldquo;You&rsquo;ll make a fine
            missionary.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Anna laced her fingers through his, feeling the tingle climb up her arm.
            &ldquo;Really?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Absolutely.&rdquo; Daniel smiled down at her. &ldquo;Like
            strawberries and cream after a taste of me, eh?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Anna had no idea what came over her. She looked him right in the eye.
            &ldquo;You tell me...&rdquo; She leaned toward him, closer than was
            polite.</span
          >
        </p>
        <p class="c1">
          <span class="c0">Daniel blinked. &ldquo;What?&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c5"
            >She grabbed the sleeve of his shirt and pulled him down till he lay across
            her; not an easy thing to do to someone immaterial. &ldquo;I </span
          ><span class="c4">am</span
          ><span class="c0">&nbsp;grateful that you saved me.&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel brought his face down nearer to hers.
            &ldquo;Anna&hellip;&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;Yes?&rdquo;</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;You do realize that I&rsquo;m dead?&rdquo; He raised his
            eyebrows.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Lovely. Cast off by the God of the Universe and then rejected romantically
            by an incorporeal being. Anna nodded and started to cry. &ldquo;Why did God
            stop me from reaching New Guinea?&rdquo; She covered her face with her
            hands. &ldquo;Am I that useless? To everyone?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">Daniel blew out a breath and sat up.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >She peeked through her fingers. He looked worried, as if he didn&rsquo;t
            want to speak for fear of hurting her feelings. She knew it! Useless!
            Capable of being a rescue mission for a ghost, but that&rsquo;s all. Not
            even good enough for a pagan stewpot. &ldquo;Go ahead,&rdquo; she sobbed.
            &ldquo;Say it.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">Daniel swallowed. &ldquo;Anna, are you&hellip;&rdquo;</span>
        </p>
        <p class="c1"><span class="c0">&ldquo;What?&rdquo;</span></p>
        <p class="c1">
          <span class="c5"
            >&ldquo;Is it&hellip;&rdquo; He shrugged and grimaced. &ldquo;Well, is it
            that </span
          ><span class="c4 c9">time?&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Anna rose slowly to her feet, and Daniel was smart enough to run.</span
          >
        </p>
        <p class="c1"><span class="c0">***</span></p>
        <p class="c1">
          <span class="c0"
            >Beach-hair is severely overrated, at least after four months with no
            shampoo. Daniel never complained, but tonight he&rsquo;d built a bonfire on
            the beach, and she wished she could have made a better showing.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;You look lovely,&rdquo; said Daniel, as she approached. &ldquo;Your
            gown grows thinner every day.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >She held out a hand for him to kiss. &ldquo;As does your
            charm.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >He gestured toward the blanket spread on the sand. &ldquo;I would stop, but
            I simply love the way your face falls whenever I mention it.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;You said God sent us here to punish you, not me.&rdquo; Anna lay
            down on her back, stretching out fully, toes to fingertips.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;He did.&rdquo; Daniel started at her. &ldquo;And he is doing a
            marvelous job of it.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Anna rolled on her side and smiled. He might be dead, and she might be a
            virgin, but there was no mistaking that look. &ldquo;Can we dance,
            now?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel hit the button on the solar-charged radio and reached for her hand.
            Tonight, the signal came in especially clear as they stepped across the
            sand. Daniel was just as intangible and indistinct as ever, but tonight, to
            Anna, it hardly mattered. She rested her head his chest and pretended that
            all lovers were as untouchable. &ldquo;Can I say something awful,
            Daniel?&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;I would be honored.&rdquo;</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;I&rsquo;m glad you&rsquo;re dead.&rdquo; She looked up into his
            slightly offended face. &ldquo;If you weren&rsquo;t, he&rsquo;d have given
            you to someone better than I am.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel pushed her out into a spin and brought her back. &ldquo;It&rsquo;s a
            wonder he gives you anything at all with that level of faith.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Exactly.&rdquo; She lay her head back down. &ldquo;Maybe God is
            punishing both of us; only is hasn&rsquo;t started just yet. And it&rsquo;s
            going to be awful.&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;I&rsquo;m sorry.&rdquo;</span></p>
        <p class="c1"><span class="c0">***</span></p>
        <p class="c1">
          <span class="c0"
            >Massimo and Bianca arrived unexpectedly, only a week later. Anna argued
            that she should hide on the other side of the island until the last day of
            their vacation so they could have more time together, and Daniel had finally
            agreed. He&rsquo;d been afraid that something would go wrong and he might
            lose his chance to see her safely rescued. Nothing did, but by the end of
            the two weeks, she wished that she&rsquo;d listened to him. It was worse
            this way; nothing but dread.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >They sat together on the beach waiting for their last sunrise. &ldquo;What
            kind of reward will you get, do you think?&rdquo; said Anna.</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;Mm?&rdquo;</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;From the Lord, for being martyred and rescuing me.&rdquo; The breeze
            blew Anna&rsquo;s hair into her face, and she brushed it away. &ldquo;Once
            your soul can rest.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;You think I&rsquo;m ready for that, do you?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Well,&rdquo; Anna bit her lip, &ldquo;Eventually, then. What do you
            think Heaven will be like?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">Daniel sighed. &ldquo;I don&rsquo;t know.&rdquo;</span>
        </p>
        <p class="c1"><span class="c0">&ldquo;Are you excited?&rdquo;</span></p>
        <p class="c1">
          <span class="c5"
            >&ldquo;I wouldn&rsquo;t use that word, no. But I truly
            believe&mdash;&rdquo; He lifted his hand and cupped her face. &ldquo;I </span
          ><span class="c4">know</span
          ><span class="c0"
            >&nbsp;that it will be wonderful, considering what I&rsquo;ve
            lost.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">&ldquo;I&rsquo;m happy for you, Daniel.&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >He smiled, but she could hardly make it out. A yellow glow grew steadily
            behind him, blurring his features, separating sky from sea.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;I&rsquo;m lying, you idiot!&rdquo; said Anna. &ldquo;Don&rsquo;t
            smile.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >He laughed and opened his mouth to speak, and then&hellip;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Nothing. Anna stared through the space where he&rsquo;d been, out at the
            sun rising over the ocean. She stood up, dusted the sand off her dress, and
            started walking toward the cottage. But she did not cry.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >There&rsquo;d be leisure enough for that after this next mistake.</span
          >
        </p>
        <p class="c1">
          <span class="c0">Martyr-smartyr. This thing was not over.</span>
        </p>
        <p class="c1"><span class="c0">***</span></p>
        <p class="c1">
          <span class="c0"
            >Anna stood on the rail of Massimo&rsquo;s yacht, smiling down at the
            moonlit water as it rushed past. Daniel might think that he was doing his
            duty, and perhaps he was, but whoever said that she had to go along with it?
            Anna didn&rsquo;t know God&rsquo;s plans&mdash;he hadn&rsquo;t exactly seen
            fit to reveal them to her through any of this mess&mdash;but she did know
            love. And what higher reason is there to do anything, anyway? It would
            probably be fine. Probably.</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Come get me, sweetheart,&rdquo; she said, and jumped.</span
          >
        </p>
        <p class="c1"><span class="c0">***</span></p>
        <p class="c1">
          <span class="c0"
            >Anna lay on her back, moonlight flickering over her eyelids. She could hear
            the crash of waves on the sand and the wind rushing through the trees. And
            she was dead. She could feel it as sure as she&rsquo;d ever felt
            alive.</span
          >
        </p>
        <p class="c1">
          <span class="c0">&ldquo;Now you&rsquo;ve done it,&rdquo; said Daniel.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >She opened her eyes and glared at him. &ldquo;You let me die!&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Daniel shrugged and sputtered. &ldquo;How could I know you were out there
            drowning?&rdquo; he said, his handsome face solid and distinct for the first
            time. &ldquo;I&rsquo;m dead, not omniscient.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Perfect.&rdquo; Anna lifted her dead head and banged it back against
            the sand. &ldquo;Now I&rsquo;m stranded here with you.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">Daniel swallowed. &ldquo;Is that so bad, then?&rdquo;</span>
        </p>
        <p class="c1">
          <span class="c0"
            >Tears filled her dead eyes. &ldquo;No, it&rsquo;s just&hellip; now that
            I&rsquo;ve got what I wanted, I see how evil it was. Did poor Mossimo have
            to find my dead body?&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">Daniel didn&rsquo;t answer.</span></p>
        <p class="c1">
          <span class="c0"
            >She inhaled, trying to steady her voice. &ldquo;And then there&rsquo;s
            you&mdash;I mean, I stranded you here and now you have no chance of
            completing your mission.&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;Mission?&rdquo;</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;To see me rescued.&rdquo; Anna opened her eyes. &ldquo;Why are you
            laughing?&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">Daniel turned his face away.</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;What?&rdquo; she snapped. &ldquo;Why are you laughing?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >He looked back at her, barely composed. &ldquo;It became clear to me after
            a while that my time here never had much to do with whether you were rescued
            successfully or not.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Of course it did,&rdquo; said Anna, blinking. &ldquo;Why else would
            you have been stuck with me all these months and months?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;And months,&rdquo; said Daniel, grinning. &ldquo;And
            months&hellip;&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >Anna gasped, horrified. &ldquo;You were right, after all. I&rsquo;m your
            penance.&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0">&ldquo;A blessed pain,&rdquo; he said quietly.</span>
        </p>
        <p class="c1">
          <span class="c0"
            >She nodded, trying to accept this. It burned, no doubt. &ldquo;And now
            I&rsquo;m dead, too.&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">&ldquo;Quite dead.&rdquo;</span></p>
        <p class="c1">
          <span class="c0"
            >&ldquo;Which means that you&rsquo;re my&hellip;&rdquo; Anna swallowed hard
            with her dead throat. &ldquo;We&rsquo;re never getting off this island, are
            we?&rdquo;</span
          >
        </p>
        <p class="c1">
          <span class="c0"
            >&ldquo;It&rsquo;s going to be a while,&rdquo; Daniel laughed,
            &ldquo;yes.&rdquo;</span
          >
        </p>
        <p class="c1"><span class="c0">Anna started crying.</span></p>
        <p class="c3">
          <span class="c0">Daniel laughed. And then he kissed her.</span>
        </p>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionContent',

    props: {
      id: String,
      text: String,
    },
  }
</script>
